var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "057-graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.625 0.875H11.375C10.8918 0.875 10.5 1.26675 10.5 1.75V26.25C10.5 26.7332 10.8918 27.125 11.375 27.125H16.625C17.1082 27.125 17.5 26.7332 17.5 26.25V1.75C17.5 1.26675 17.1082 0.875 16.625 0.875Z",
    fill: "#717579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.375 9.625H20.125C19.6418 9.625 19.25 10.0168 19.25 10.5V26.25C19.25 26.7332 19.6418 27.125 20.125 27.125H25.375C25.8582 27.125 26.25 26.7332 26.25 26.25V10.5C26.25 10.0168 25.8582 9.625 25.375 9.625Z",
    fill: "#717579"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.875 16.625H2.625C2.14175 16.625 1.75 17.0168 1.75 17.5V26.25C1.75 26.7332 2.14175 27.125 2.625 27.125H7.875C8.35825 27.125 8.75 26.7332 8.75 26.25V17.5C8.75 17.0168 8.35825 16.625 7.875 16.625Z",
    fill: "#717579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderReports);
export default __webpack_public_path__ + "static/media/header-reports.9486b2d34824805c19d9109d3c58f154.svg";
export { ForwardRef as ReactComponent };